<template>
  <div class="ws-data-expand-list">
    <div
      v-if="searchMode"
      class="search-section"
    >
      <WsSearchInput
        @submit="$_onSearchSubmit()"
        v-model="searching"
        :placeholder="`搜尋${label}`"
      ></WsSearchInput>
      <WsBtn @click="$_onSearchSubmit()">搜尋</WsBtn>
    </div>
    <div
      class="ws-data-expand-list__content"
      ref="infiniteList"
    >

      <div v-if="hasCatchVersion">
        <WsInfiniteScrollWrap002
          modelName="risk_template"
          :params="params"
          :parentLayers="[{name:'system_class'},{name:'system_subclass'}]"
          :parentModels="_filterDatas"
        >
          <template v-slot="{items}">
            <div
              v-for="(modelData,modelIndex) in items"
              :key="modelData.id+modelIndex"
              class="mb-5"
            >
              <div
                class="ws-data-expand-list__chapters"
                v-if="$_isInfiniteScrollTitle(modelIndex,items)"
              >
                {{modelData[filterSubName].name}}
              </div>
              <WsDataExpandListItem
                :modelName="modelName"
                :titleKey="titleKey"
                :modeVersions="modeVersions"
                :value="modelData"
                :modelId="modelData.id"
                :fields="fields"
                :fieldsRead="fieldsRead"
                :locale="locale"
                :hideOnNull="hideOnNull"
                :parentModelName="parentModelName"
                :createVersion="createVersion"
                :itemVersionCreatable="itemVersionCreatable"
                :itemVersionLinkCreatable="itemVersionLinkCreatable"
                :itemVersionReadable="itemVersionReadable"
                :itemDeletable="itemDeletable"
                :itemEditable="itemEditable"
                :itemLinkCheckable="itemLinkCheckable"
                :params="params"
                :isGetAll="isGetAll"
                :modelVersionName="modelVersionName"
                :modelData="modelData"
                :hasSequence="hasSequence"
                :hasChapters="hasChapters"
                :hasCatchVersion="hasCatchVersion"
                :customParentData="customParentData"
                :expandDisable="expandDisable"
                @delete="$_onDelete($event)"
                @update-submit="$_onUpdateSubmit($event)"
              ></WsDataExpandListItem>
            </div>
          </template>
        </WsInfiniteScrollWrap002>
      </div>
    </div>
    <div
      v-if="fetchLoading"
      class="mt-5"
    >
      <v-skeleton-loader
        v-for="n in 3"
        :key="`skeleton-${n}`"
        type="list-item-three-line"
        :tile="true"
        class="mt-5"
      ></v-skeleton-loader>
    </div>
    <WsCard v-if="createModeActive">
      <ValidationObserver ref="form">
        <WsStateForm
          :generalFields="_updateFields"
          @isCompleted="$_isFormCompleted($event,value)"
          :modelData="modelData"
          :value="createData"
          :customParentData="customParentData"
          :updateData="_updateData"
          @input="$_onInput($event)"
        ></WsStateForm>
      </ValidationObserver>
      <v-divider></v-divider>
      <v-card-actions class="pa-5">
        <v-spacer></v-spacer>
        <WsBtn
          @click="$_onCreateCancel()"
          minWidth="100px"
          color="textSecondary"
          outlined
        >取消</WsBtn>
        <WsBtn
          @click="$_onCreateSubmit()"
          minWidth="100px"
          :loading="createSubmitLoading"
          color="primary"
        >儲存</WsBtn>
      </v-card-actions>
    </WsCard>
    <div
      v-else
      class="ws-button-group"
    >
      <WsBtn
        v-if="this.hasChapters"
        :to="`${this.$route.path}/add_chapter`"
        color="primary"
        outlined
        block
      >
        <v-icon left>mdi-plus</v-icon> 新增題目
      </WsBtn>
      <WsBtn
        v-else-if="tabSetting "
        @click="$_multiSelectOpen()"
        color="primary"
        outlined
        block
      >
        <v-icon left>mdi-plus</v-icon> 新增{{tabActiveName}}
      </WsBtn>
      <WsBtn
        v-else-if="!hasCatchVersion"
        @click="$_createOpen()"
        color="primary"
        outlined
      >
        <v-icon left>mdi-plus</v-icon> 單筆新增{{label}}
      </WsBtn>
      <WsBtn
        v-show="batchMode"
        :to="`${_batchLink}?redirect=${$route.fullPath}`"
        color="primary"
      >前往批次上傳模式</WsBtn>
    </div>
    <WsMultiSelectDialog
      ref="multiSelectDialog"
      title="新增工廠"
      :filterSelects="filterSelects"
      :label="label"
      :fields="fields"
      :modelName="modelName"
      :lastPage="lastPage"
      :showExpand="showExpand"
      :isMultiSelect="isMultiSelect"
      :showFields="showFields"
      @submit="$_onMultiSelectSubmit($event)"
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    searching: "",
    modelDatas: [],
    createModeActive: false,
    createData: {},
    createSubmitLoading: false,
    fetchLoading: false,
    page: 1,
    lastPage: 10,
    totalData: 0,
    isCatching: false,
    isCreated: false,
    tabActiveName: "",
    stopFetch: false,
    filterDatas: null,
  }),
  methods: {
    $_onInput($event) {
      this.createData = $event;
    },
    $_onSearchSubmit() {
      this.fetchData();
    },
    $_onUpdateSubmit($event) {
      if (this.hasSequence) {
        const _index = this.modelDatas.findIndex((e) => {
          return e.last_version.id == $event.id;
        });
        this.modelDatas[_index].last_version = {
          ...this.modelDatas[_index].last_version,
          ...$event,
        };
      } else {
        const _index = this.modelDatas.findIndex((e) => {
          return e.id == $event.id;
        });
        this.modelDatas[_index].last_version = {
          ...this.modelDatas[_index].last_version,
          ...$event,
        };
      }
    },
    async $_onDelete($event) {
      const tarIndex = this.modelDatas.findIndex((e) => {
        return e.id == $event;
      });
      this.modelDatas.splice(tarIndex, 1);
      this.totalData--;
      this.$emit("deleted", $event);
    },
    $_onCreateCancel() {
      this.createModeActive = false;
    },
    async $_onCreateSubmit() {
      const isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return;
      }
      try {
        this.fetchLoading = true;
        this.createSubmitLoading = true;

        if (this.hasSequence) {
          let postData = JSON.parse(
            JSON.stringify(this.createData.last_version)
          );
          //新增題目
          let newData = {};
          newData = JSON.parse(JSON.stringify(this.params));
          try {
            const res = await this.$axios.post(`/${this.modelName}`, newData);
            try {
              //新增題目版本
              //綁新題目
              //this.modelName
              postData[`${this.modelName}`] = res.data.data.id;
              //綁原本公版版本
              postData = {
                ...postData,
                ...this.postData,
              };
              //題目版本的 status
              if (this.customParentData.version_status) {
                postData.status = this.customParentData.status;
              } else {
                postData.status = 0;
              }
              const versionRes = await this.$axios.post(
                `/${this.modelVersionName}`,
                postData
              );
              //更新顯示題目資料
              let newObj = {};
              newObj.id = res.data.data.id;
              newObj.last_version = versionRes.data.data;
              this.modelDatas.push(newObj);
              this.$emit("created", res.data.data);
              try {
                this.createModeActive = false;
                this.createSubmitLoading = false;
                this.fetchLoading = false;
              } catch (error) {
                alert(error, "新增題目錯誤");
                this.createSubmitLoading = false;
              }
            } catch (error) {
              alert(error, "新增題目版本錯誤");
              this.createSubmitLoading = false;
            }
          } catch (error) {
            alert(error, "更新公版題目錯誤");
            this.createSubmitLoading = false;
          }
        } else {
          const postUrl =
            this.parentState && this.parentModelName
              ? `/${this.parentModelName}/${this.parentState}/${this.modelName}`
              : `/${this.modelName}`;
          const postData = JSON.parse(JSON.stringify(this.createData));
          const res = await this.$axios.post(postUrl, postData);
          this.createModeActive = false;
          if (this.modeVersions) {
            try {
              await this.$axios.post(
                `/${this.modelName}/${res.data.data.id}/${this._versionModelName}`,
                this.createData.last_version
              );
              this.createSubmitLoading = false;
              //更新local題目資料
              await this.fetchData();
            } catch (error) {
              alert("新增錯誤");
              this.createSubmitLoading = false;
            }
          } else {
            this.createSubmitLoading = false;
            this.fetchData();
          }
        }
      } catch (error) {
        alert("新增錯誤");
        this.createSubmitLoading = false;
      }
    },
    $_createOpen() {
      this.$_CMS_updateDataSetFromFields(this, this.createData, this.fields);
      this.createModeActive = true;
    },
    $_multiSelectOpen() {
      this.$refs.multiSelectDialog.open();
    },
    async fetchData() {
      if (this.isCatching || this.stopFetch) {
        return;
      }
      if (this.isGetAll) {
        this.stopFetch = true;
      }
      if (this.page > this.lastPage) {
        return;
      }
      this.fetchLoading = true;
      this.isCatching = true;
      try {
        let res = {};
        let getUrl;
        if (
          this.parentState &&
          this.parentModelName &&
          !this.hasChapters &&
          !this.hasSequence &&
          !this.hasCatchVersion
        ) {
          getUrl = `/${this.parentModelName}/${this.parentState}/${this.modelName}`;
        } else if (
          this.hasSequence ||
          this.hasChapters ||
          this.hasCatchVersion
        ) {
          getUrl = `/${this.modelName}`;
        } else {
          getUrl = `/${this.modelName}`;
        }
        let params = {
          search: this.searching,
          lang: this.locale,
          order_by: this.orderBy,
          order_way: this.orderWay,
          page: this.page,
          ...this.params,
        };
        res = await this.$axios.get(getUrl, {
          params: params,
        });
        this.modelDatas = [...this.modelDatas, ...res.data.data];
        if (res.data.meta) {
          this.page = res.data.meta.current_page;
          this.lastPage = res.data.meta.last_page;
          this.totalData = res.data.meta.total;
        }
        this.page++;
      } catch (error) {
        alert(error);
      } finally {
        this.fetchLoading = false;
        this.isCatching = false;
      }
    },
    $_scrollHandle(e) {
      if (!this.$refs.infiniteList) return;
      const scrollElm = e.target.scrollingElement;
      const listElm = this.$refs.infiniteList.getBoundingClientRect();
      if (
        listElm.height < window.innerHeight ||
        scrollElm.scrollTop + scrollElm.clientHeight >=
          scrollElm.scrollHeight - 100
      ) {
        this.fetchData();
      }
    },
    $_onTabInput($event) {
      this.modelName = $event[0];
      this.tabActiveName = $event[1];
      this.fetchData();
    },
    $_getConditions(fieldKey) {
      const _conditions = [];
      const conditionKeys = this.$_getFieldAttr(fieldKey, "conditionKeys");
      if (!conditionKeys) {
        return [];
      }
      conditionKeys.forEach((conditionKey) => {
        _conditions.push({
          key: conditionKey.conditionName,
          value: this.value[conditionKey.fieldName],
          type: conditionKey.type,
        });
      });
      return _conditions;
    },
    $_fixedButtonVisible() {
      if (!this.$refs.titleButton) return;
      let titleButton = this.$refs.titleButton.getBoundingClientRect();
      let titleButtonPosition = titleButton.y + titleButton.height;
      if (this.position.scrollTop > titleButtonPosition) {
        this.fixedButtonActive = true;
      } else {
        this.fixedButtonActive = false;
      }
    },
    $_getSideData() {
      try {
        let params = {};
        params.area = this.customParentData.area;
        this.$axios.get(`/system_class`, { params: params });
      } catch (error) {
        alert(error);
      }
    },
    async $_getFilterDatas() {
      if (!this.filterName) return;
      try {
        const res = await this.$axios.get(`/${this.filterName}`);
        this.filterDatas = res.data.data;
      } catch (error) {
        alert(error);
      }
    },
    $_isInfiniteScrollTitle(modelIndex, items) {
      if (modelIndex == 0) {
        return true;
      } else if (
        items[modelIndex][this.filterSubName].name !=
        items[modelIndex - 1][this.filterSubName].name
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  computed: {
    _sequenceFields() {
      let newArr = [];
      if (this.hasSequence) {
        if (!this.sequenceFields) return;
        this.sequenceFields.forEach((sequenceItem) => {
          let questionIndex = this.modelDatas.findIndex((e) => {
            //題目資料
            return e.id == sequenceItem.id;
          });
          if (!this.modelDatas[questionIndex]) {
            return;
          } else {
            newArr.push(this.modelDatas[questionIndex]);
          }
        });
      } else if (this.hasChapters) {
        if (!this.sequenceFields || this.modelDatas.length === 0) return;
        newArr = JSON.parse(JSON.stringify(this.sequenceFields));
        this.sequenceFields.forEach((chapterItem, chapterIndex) => {
          chapterItem.sections.forEach((sectionItem, sectionIndex) => {
            sectionItem.topics.forEach((topicItem, topicIndex) => {
              let index = this.modelDatas.findIndex((e) => {
                return e.id == topicItem.id;
              });
              newArr[chapterIndex].sections[sectionIndex].topics[topicIndex] =
                this.modelDatas[index];
            });
          });
        });
      } else if (this.hasCatchVersion) {
        newArr = JSON.parse(JSON.stringify(this.sequenceFields));
      }

      return newArr;
    },
    _updateData() {
      let _updateData = JSON.parse(JSON.stringify(this.modelData));
      this.$_CMS_updateDataSetFromFields(this, _updateData, this.fields);
      return _updateData;
    },
    _updateFields() {
      return this.$_CMS_geUpdateFields(this.fields);
    },
    _batchLink() {
      if (this.parentModelName && this.parentState) {
        return `/${this.parentModelName}/${this.parentState}/${this.modelName}/create/batch`;
      } else {
        return `/${this.modelName}/create/batch`;
      }
    },
    _versionModelName() {
      return `${this.modelName}_version`;
    },
    _totalModel() {
      if (this.totalData > 0) {
        return this.totalData;
      } else {
        return this.modelDatas.length;
      }
    },
    _filterDatas() {
      if (!this.filterDatas || !this.customParentData) return;
      let _filterDatas = this.filterDatas
        .map((item) => {
          let _system_subclass = item.system_subclasses
            .map((subItem) => {
              return {
                id: subItem.id,
                name: subItem.name,
              };
            })
            .filter((filterItem) => {
              if (
                this.customParentData[this.filterSubName].find((findItem) => {
                  return findItem.id === filterItem.id;
                })
              ) {
                return filterItem;
              }
            });
          let filterObj = {
            id: item.id,
            name: item.name,
            system_subclass: _system_subclass,
          };
          return filterObj;
        })
        .filter((filterItem) => {
          if (
            this.customParentData[this.filterName].find((findItem) => {
              return findItem.id === filterItem.id;
            })
          ) {
            return filterItem;
          }
        });
      let _allSubfilter = this.customParentData[this.filterSubName].map(
        (item) => {
          return {
            id: item.id,
            name: item.name,
          };
        }
      );
      let filterObj = {};
      let _filterSubclassName = "";
      if (this.isSubclassMulti) {
        _filterSubclassName = "system_subclasses";
      } else {
        _filterSubclassName = "system_subclass";
      }
      let _filterClassName = "";
      if (this.isClassMulti) {
        _filterClassName = "system_classes";
      } else {
        _filterClassName = "system_class";
      }
      filterObj[_filterClassName] = _filterDatas;
      filterObj[_filterSubclassName] = _allSubfilter;
      return filterObj;
    },
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
  },
  watch: {
    position() {
      this.$_fixedButtonVisible();
    },
    params: {
      handler() {
        if (this.params && this.fetchWithParams) {
          this.page = 1;
          this.modelDatas = [];
          this.fetchData();
        }
      },
    },
  },
  props: {
    modeVersions: {
      type: Boolean,
      default: false,
    },
    batchMode: {
      type: Boolean,
      default: false,
    },
    searchMode: {
      type: Boolean,
      default: false,
    },
    locale: {
      type: String,
      default: null,
    },
    titleKey: {
      type: String,
      default: null,
    },
    modelName: {
      type: String,
      default: null,
    },
    modelTemplateName: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: null,
    },
    parentModelName: {
      type: String,
      default: null,
    },
    parentState: {},
    fields: {
      type: Object,
      default: null,
    },
    fieldsRead: {
      type: Array,
      default: null,
    },
    orderBy: {
      type: String,
      default: "sequence",
    },
    orderWay: {
      type: String,
      default: "asc",
    },
    subVersionFields: {
      type: Object,
      default() {
        return {};
      },
    },
    subVersionFieldsReads: {
      type: Array,
      default() {
        return [];
      },
    },
    rootModelName: {
      type: String,
      default: "",
    },
    hideOnNull: {
      type: Boolean,
      default: true,
    },
    filterSelects: {
      type: Array,
      default: null,
    },
    isMultiSelect: {
      type: Boolean,
      default: false,
    },
    showExpand: {
      type: Boolean,
      default: true,
    },
    showFields: {
      type: Array,
    },
    tabSetting: {
      type: Array,
    },
    multiTomulti: {
      type: Boolean,
      default: false,
    },
    createVersion: {
      type: Boolean,
      default: false,
    },
    modelData: {
      type: Object,
      default() {
        return {};
      },
    },
    itemVersionCreatable: {
      type: Boolean,
    },
    itemVersionLinkCreatable: {
      type: Boolean,
    },
    itemVersionReadable: {
      type: Boolean,
    },
    itemEditable: {
      type: Boolean,
    },
    itemDeletable: {
      type: Boolean,
    },
    itemLinkCheckable: {
      type: Boolean,
    },
    params: {
      type: Object,
    },
    sequenceFields: {
      type: Array,
    },
    postData: {
      type: Object,
    },
    isGetAll: {
      type: Boolean,
      default: false,
    },
    modelVersionName: {
      type: String,
      default: "",
    },
    hasSequence: {
      type: Boolean,
      default: false,
    },
    hasChapters: {
      type: Boolean,
      default: false,
    },
    hasCatchVersion: {
      type: Boolean,
      default: false,
    },
    customParentData: {
      type: Object,
    },
    expandDisable: {
      type: Boolean,
      default: false,
    },
    filterName: {
      type: String,
    },
    filterSubName: {
      type: String,
    },
    isSubclassMulti: {
      type: Boolean,
      default: false,
    },
    fetchWithParams: {
      type: Boolean,
    },
  },
  created() {
    window.addEventListener("scroll", this.$_scrollHandle);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.$_scrollHandle);
  },
  mounted() {
    this.fetchData();
    this.$_getFilterDatas();
    this.$_CMS_updateDataSetFromFields(this, this.createData, this.fields);
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-data-expand-list.scss";
</style>